import { Injectable } from '@angular/core';
import { Observable, Subject, Observer } from 'rxjs';

import { Generic } from '@core/generic.model';

@Injectable({
	providedIn: 'root'
})
export class SocketService {
	private ws!: WebSocket;

	public connect(url: string): Subject<MessageEvent> {
		return this.create(url);
	}

	public disconnect() {
		this.ws.close();
	}

	private create(url: string): Subject<MessageEvent> {
		this.ws = new WebSocket(url);
		let dataToSend: Generic = {};

		this.ws.onopen = e => {
			this.ws.send(JSON.stringify(JSON.stringify('hand shake')));
			if (dataToSend !== {}) {
				this.ws.send(JSON.stringify(dataToSend));
			}
		};

		const observable = Observable.create((obs: Observer<MessageEvent>) => {
			this.ws.onmessage = obs.next.bind(obs);
			this.ws.onerror = obs.error.bind(obs);
			this.ws.onclose = obs.complete.bind(obs);
			return this.ws.close.bind(this.ws);
		});

		const observer = {
			next: (data: Generic) => {
				if (this.ws.readyState === WebSocket.OPEN) {
					this.ws.send(JSON.stringify(data));
				} else {
					dataToSend = data;
				}
			},
			complete: () => {
				this.ws.close();
			}
		};

		return Subject.create(observer, observable);
	}
}
